import { Component, OnInit } from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {OverlayConfig, OverlayRef} from 'exc-controls';

@Component({
  selector: 'app-provider-modal-import-by-client',
  templateUrl: './provider-modal-import-by-client.component.html',
  styles: []
})
export class ProviderModalImportByClientComponent extends  ExcTranslation implements OnInit {
  selectedClient = 0;
  clients: any[] = [];
  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.clients = _self.overlayConfig.data.Client;
  }
  export() {
    const _self = this;
    if (_self.selectedClient === 0) {
      _self.selectedClient = null;
    }
    _self.overlayRef.close({proceed: true, selectedClient: _self.selectedClient});
  }

}
